import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faCalendarAlt, faEdit, faFilter, faHashtag, faPlus, faSync, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        Permisos: [],
        Departamentos: [],
        Municipios: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar la Cotización?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("cotizaciones/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarArrayResultado(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    departamentos() {
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                //console.log(datosRespuesta);
                this.setState({ Departamentos: datosRespuesta.data.data });
            })
            .catch(console.log);
    }
    ListarArrayResultado(page) {
        Swal.showLoading();
        let bcotizacion = document.getElementById('bcotizacion').value;
        let bname = document.getElementById('bnombre').value;
        let dep = document.getElementById('bnombredep').value;
        let bfecha = document.getElementById('bfecha').value;
        let estado = document.getElementById('bestado').value;
        var datos = { cotizacion: bcotizacion, dep: dep, mun: bname, fecha: bfecha, estado: estado }
        authAxios.post("cotizaciones/index?page=" + page, datos)
            .then((datosRespuesta) => {
                //console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', arrayResultado: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    ConsultarPermiso() {

        let user = localStorage.getItem('idusuario');
        let url = 'MasterCotizaciones';

        authAxios.get("roles/PermisoModulo/" + user + "/" + url + "")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Permisos: datosRespuesta.data.data });

            })
            .catch(console.log);
    }
    cargarMunicipios(id_cod_dpto, id_cod_mpio) {
        Swal.showLoading();
        console.log('dep:' + id_cod_dpto);
        authAxios.get("municipios_visitas/buscardepartamento/" + id_cod_dpto)
            .then((datosRespuesta) => {
                //console.log(datosRespuesta);
                this.setState({ Municipios: datosRespuesta.data });

                window.$("#bnombre").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    buscarMunicipios() {
        Swal.showLoading();
        var id_cod_dpto = document.getElementById("bnombredep").value;
        if (id_cod_dpto != '') {
            this.cargarMunicipios(id_cod_dpto, '');
        }

    }
    componentDidMount() {
        this.ConsultarPermiso();
        this.ListarArrayResultado(1);
        this.departamentos();
    }
    render() {
        const { load, arrayResultado, pagina, ultimo, actual, Permisos, Departamentos, Municipios } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            {Permisos.registrar == 1 ?
                                <Link className="btn btn-success btn-sm" to={"/AddCotizaciones"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Cotización</Link>
                                : ''}
                        </div>
                        <div className="card-body">
                            <h4>Lista Cotizaciones</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bcotizacion" name="bcotizacion" placeholder="No. Cotización" className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className="col-xl-2">

                                    <select name="bnombredep" id="bnombredep"
                                        onChange={e => {
                                            this.buscarMunicipios(e);

                                        }}
                                        className={"form-select form-select-sm"}>
                                        <option value="">Seleccione el Departamento</option>
                                        {
                                            Departamentos.map((itemDepartamentos) => (
                                                <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-xl-2">

                                    <select name="bnombre" id="bnombre" className={" form-select form-select-sm"}>
                                        <option value="">Seleccione el Municipio</option>
                                        {
                                            Municipios.map((item) => (
                                                <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-xl-2">

                                    <select name="bestado" id="bestado" className={" form-select form-select-sm"}>
                                        <option value="">Seleccione el Estado</option>
                                        <option value="1">En proceso</option>
                                        <option value="2">Congelado</option>
                                        <option value="4">Aprobado</option>
                                        <option value="3">Anulado</option>

                                    </select>
                                </div>
                                <div className="col-xl-2">
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                        <input style={{ textTransform: 'uppercase' }} type="date" id="bfecha" name="bfecha" placeholder="Fecha Cot." className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className="col-xl-2">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">COT. / VER.</th>
                                            <th className="align-middle">DEPARTAMENTO</th>
                                            <th className="align-middle">MUNICIPIO</th>
                                            <th className="align-middle">FEC. REG.</th>
                                            <th className="align-middle">AÑO INICIO</th>
                                            <th className="align-middle">AÑO FINAL</th>
                                            <th className="align-middle">ESTADO</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            Permisos.consultar == 1 ?
                                                arrayResultado.map((itemArrayResultado) => (
                                                    <tr key={itemArrayResultado.ID_COTIZACION}>
                                                        <td>{itemArrayResultado.NO_COTIZACION}-{itemArrayResultado.VERSION}</td>
                                                        <td>{itemArrayResultado.DEPARTAMENTO}</td>
                                                        <td>{itemArrayResultado.MUNICIPIO}</td>
                                                        <td>{itemArrayResultado.FECHA_CREACION.substr(0, 10)}</td>
                                                        <td>{itemArrayResultado.FECHA_INICIO}</td>
                                                        <td>{itemArrayResultado.FECHA_FINAL}</td>
                                                        <td>
                                                            {
                                                                (() => {
                                                                    switch (itemArrayResultado.ESTADO_COTIZACION) {
                                                                        case 1:
                                                                            return (<span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF', fontWeight: 'bold' }} className="badge bg-primary">EN PROCESO</span>)
                                                                        case 2:
                                                                            return (<span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF', fontWeight: 'bold' }} className="badge bg-info">CONGELADO</span>)
                                                                        case 3:
                                                                            return (<span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF', fontWeight: 'bold' }} className="badge bg-danger">ANULADO</span>)
                                                                        case 4:
                                                                            return (<span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF', fontWeight: 'bold' }} className="badge bg-success">APROBADO</span>)
                                                                        case 5:
                                                                            return (<span style={{ fontSize: 11, textTransform: 'uppercase', color: '#FFFFFF', fontWeight: 'bold' }} className="badge bg-warning">AUDITADO</span>)
                                                                    }
                                                                })()
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                {Permisos.editar == 1 ?
                                                                    <Link
                                                                        className="btn btn-primary btn-sm"
                                                                        to={"/UpCotizaciones/" + itemArrayResultado.ID_COTIZACION}
                                                                    >
                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                    </Link> : ''}
                                                                &nbsp;&nbsp;
                                                                {Permisos.eliminar == 1 ?
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() =>
                                                                            this.borrarRegistros(itemArrayResultado.ID_COTIZACION)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button> : ''}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                )) :
                                                <tr>
                                                    <td colSpan={8}>No Tienes Permisos para ver la tabla</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;